import { Card, Col, Row } from 'react-bootstrap'
import {
  PIM_EMP_WELFARE,
  PIM_EMP_WELFARE_EJIP,
  PIM_EMP_WELFARE_LEAVE,
  PIM_EMP_WELFARE_LOAN_HOME,
  PIM_EMP_WELFARE_PVD
} from '../../../../router/routes'
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams
} from 'react-router-dom'
import Fuel from './../../../../images/Fuel.svg'
import Calendar from './../../../../images/calendar.svg'
import SmartPhone from './../../../../images/Smart Phone.svg'
import EJIP from './../../../../images/EJIP.svg'
import PVD from './../../../../images/PVD.svg'
import ASS from './../../../../images/assistance.svg'
import { Image } from 'react-bootstrap'
import { getWelfareAPI } from '../../../../services/welfare-pvd'
import { useEffect, useState } from 'react'
import { getIncomeLoanHomeAccountDetailAPI } from '../../../../services/income/loan-home'

function EmpWelfare() {
  const navigate = useNavigate()
  const locaiton = useLocation()
  const { dataUser } = useOutletContext()
  const { id } = useParams()

  const [group2, setGroup2] = useState([])
  const [dataResult, setDataResult] = useState([])
  const getLinkQuery = (url) => {
    // return `${url}${locaiton.search}`
    return `${url}/${id}`
  }

  useEffect(() => {
    if (dataUser) {
      const param = { code: dataUser.code, orgId: dataUser.orgId }
      getWelfare(param)
      getIncomeLoanHomeAccountDetail(param)
    }
  }, [dataUser])

  const getWelfare = async (param) => {
    const resp = await getWelfareAPI(param)
    if (!resp) return
    if (resp.status) {
      setGroup2(resp?.result?.group2)
      const newData = resp.result?.group1.map((d, i) => {
        return {
          titleName: d?.title,
          detail: d?.detail,
          limit: d?.limit
        }
      })
      setDataResult(newData)
    } else {
      setDataResult([])
      setGroup2([])
    }
  }
  const [loanHome, setLoanHome] = useState([])
  const getIncomeLoanHomeAccountDetail = async (param) => {
    const resp = await getIncomeLoanHomeAccountDetailAPI(param)
    if (!resp) return
    if (resp.status) {
      setLoanHome(resp.result)
    } else {
      setLoanHome([])
    }
  }

  const welfare = [
    {
      id: 1,
      img: Fuel,
      title: dataResult[0]?.titleName,
      limit: dataResult[0]?.limit,
      detail: dataResult[0]?.detail,
      disable: true
      // url: getLinkQuery(PIM_EMP_WELFARE_CAR),
      // url: getLinkQuery(PIM_EMP_WELFARE)
    },
    {
      id: 4,
      img: Calendar,
      title: dataResult[3]?.titleName,
      limit: dataResult[3]?.limit,
      detail: dataResult[3]?.detail,
      url: getLinkQuery(PIM_EMP_WELFARE_LEAVE)
    },
    {
      id: 5,
      img: SmartPhone,
      title: dataResult[4]?.titleName,
      limit: dataResult[4]?.limit,
      detail: dataResult[4]?.detail,
      url: '#',
      disable: true
    }
  ]
  const pvd = [
    {
      id: 1,
      img: PVD,
      color: '#603b7e',
      title: 'กองทุนสำรองเลี้ยงชีพ (PVD)',
      // detail: "ยังไม่เป็นสมาชิกกองทุน",
      detail: `${
        group2[0]?.have_pvd
          ? `เข้าร่วมสมาชิกกองทุนเรียบร้อย`
          : `ยังไม่เป็นสมาชิกกองทุน`
      }`,
      url: getLinkQuery(`${PIM_EMP_WELFARE_PVD}`)
    },
    {
      id: 2,
      img: EJIP,
      color: '#e24f56',
      title: 'EJIP',
      // detail: "ยังไม่เป็นสมาชิกกองทุน",
      detail: `${
        group2[0]?.have_ejip
          ? `เข้าร่วมสมาชิกกองทุนเรียบร้อย`
          : `ยังไม่เป็นสมาชิกกองทุน`
      }`,

      url: getLinkQuery(PIM_EMP_WELFARE_EJIP)
    },
    {
      id: 3,
      img: ASS,
      color: '#5d5d5d',
      title: 'สินเชื่อบ้าน',
      detail: `${loanHome.length} บัญชี`,
      url: getLinkQuery(PIM_EMP_WELFARE_LOAN_HOME)
    }
  ]
  return (
    <>
      <Card.Body className="overflow-auto">
        <p className="text-primary">เบิกจ่ายประจำเดือน</p>

        <Row>
          {welfare.map((w, i) => (
            <Col xl={4} key={`welfare-${i}`} className="mb-4">
              <Card
                className={`${!w?.disable && 'cursor-pointer'}`}
                border="0"
                style={{
                  backgroundColor: '#f4f9fd'
                }}
                onClick={() => !w?.disable && navigate(w?.url)}
              >
                <Card.Body>
                  <div className="d-flex">
                    <span className="d-flex align-items-center">
                      <Image
                        src={w?.img}
                        className="me-3"
                        style={{
                          height: '45px',
                          width: '45px'
                        }}
                      />
                    </span>
                    <div className="ms-3">
                      <h6 className="my-auto fw-bold box-text-1 pt-2 pb-2">
                        {w.title}
                      </h6>
                      <p className="mb-0 fw-light mt-1 box-text-1">
                        {w?.limit}
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        <p className="text-primary">การลงทุน</p>
        <Row>
          {pvd.map((d, i) => (
            <Col xl={4} key={`pvd-${i}`} className="mb-4">
              <Card
                className="cursor-pointer"
                border="0"
                style={{
                  backgroundColor: '#f4f9fd'
                }}
                onClick={() => navigate(d?.url)}
              >
                <Card.Body>
                  <div className="d-flex">
                    <span className="d-flex align-items-center">
                      <Image
                        src={d?.img}
                        className="me-3"
                        style={{
                          height: '45px',
                          width: '45px'
                        }}
                      />
                    </span>
                    <div className="ms-3">
                      <h6 className="my-auto fw-bold box-text-1 pt-2 pb-2">
                        {d.title}
                      </h6>
                      <p className="mb-0 fw-light mt-1 box-text-1">
                        {d?.detail}
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Card.Body>
    </>
  )
}

export default EmpWelfare
